import http from "./httpService";
import config from "config.json";
const { apiUrl } = config;

const REPORT_FIELDS = [
  { displayName: "Booking Id", propertyName: "BookingId", order: 1 },
  { displayName: "Booking Type", propertyName: "BookingMode", order: 2 },
  { displayName: "Booking Date", propertyName: "InvoiceDate", order: 3 },
  { displayName: "Issue Date", propertyName: "modifiedDate", order: 4 },
  { displayName: "Modified Date", propertyName: "modifiedDate", order: 34 },
  {
    displayName: "Modified By User",
    propertyName: "ModifiedByUser",
    order: 35,
  },
  { displayName: "Departure Date", propertyName: "DepartureDate", order: 14 },
  { displayName: "Departure Time", propertyName: "DepartureTime", order: 15 },
  { displayName: "Arrival Date", propertyName: "ArrivalDate", order: 16 },
  { displayName: "Arrival Time", propertyName: "ArrivalTime", order: 17 },
  { displayName: "Day to Travel", propertyName: "DayToTravel", order: 18 },
  { displayName: "Invoice Id", propertyName: "UpdatedBookingId", order: 19 },
  { displayName: "Passenger Name", propertyName: "PassengerName", order: 20 },
  { displayName: "Passenger Type", propertyName: "PassengerType", order: 21 },
  { displayName: "PNR", propertyName: "Pnr", order: 22 },
  { displayName: "Total Fare", propertyName: "NetTotalFare", order: 23 },
  { displayName: "Base Fare", propertyName: "BaseFare", order: 24 },
  { displayName: "YQ", propertyName: "YqFare", order: 25 },
  { displayName: "YR", propertyName: "YRFare", order: 26 },
  { displayName: "Tax", propertyName: "TaxFare", order: 27 },
  { displayName: "Tds", propertyName: "CarrierCommTDS", order: 28 },
  { displayName: "Gst", propertyName: "CarrierCommGst", order: 29 },
  { displayName: "Gross Fare", propertyName: "PublishTotalFare", order: 30 },
  { displayName: "Trip Type", propertyName: "TripType", order: 31 },
  {
    displayName: "oneway SSR Amount",
    propertyName: "OnewaySSRAmount",
    order: 32,
  },
  {
    displayName: "Return SSR Amount",
    propertyName: "ReturnSSRAmount",
    order: 33,
  },
  { displayName: "Payment Medium", propertyName: "PaymentMode", order: 9 },
  { displayName: "Payment Status", propertyName: "PaymentStatus", order: 10 },
  { displayName: "Description", propertyName: "Description", order: 8 },
];
const exportReportFlight = async (queryString, value) => {
  try {
    const url = `${apiUrl}/flight/selected-book-flight-list/export${
      queryString ? `?${queryString}` : ""
    }`;
    const data = await http.post(url, value, { responseType: "blob" });
    return data;
  } catch (error) {
    throw error;
  }
};
const getSalesReport = async (query) => {
  const url = `${apiUrl}/flight/sales-person-wise${query ? `?${query}` : ""}`;
  const data = await http.get(url);
  return data;
};
const getAirlineDetailsForReport = async (query) => {
  const {
    data: { data },
  } = await http.get(`${apiUrl}/flight/carrier?searchText=${query}`);
  return data;
};
const getAirportsDetailsForReport = async (query) => {
  const {
    data: { data },
  } = await http.get(`${apiUrl}/airports?searchText=${query}`);
  return data;
};
const getCountryDetailsForReport = async (query) => {
  const {
    data: { data },
  } = await http.get(`${apiUrl}/members/get-country?searchText=${query}`);
  return data;
};
const getStateDetailsForReport = async (value) => {
  const {
    data: { data },
  } = await http.get(`${apiUrl}/state/state-list/${value}`);
  return data;
};
const getSupplierForReport = async (query) => {
  const {
    data: { data },
  } = await http.get(
    `${apiUrl}/members/supplier-wise/search?searchText=${query}`,
  );
  return data;
};
const getSalesUserForReport = async (query) => {
  try {
    const {
      data: { data },
    } = await http.get(
      `${apiUrl}/authenticate/operation-users${query ? `?${query}` : ""}`,
    );
    return data;
  } catch (error) {
    throw error;
  }
};

const getSalesManagerAutoCompleteForReport = async (values, id) => {
  const url = `${apiUrl}/sales-region/sales-manager-dropdown-by-region-manager/${id}?search=${values}`;
  const data = await http.get(url);
  return data;
};

const getAreaSalesManagerAutoCompleteForReport = async (values, id) => {
  const url = `${apiUrl}/sales-region/area-manager-dropdown-by-sales-manager/${id}?search=${values}`;
  const data = await http.get(url);
  return data;
};

const getSeniorExecutiveAutoCompleteForReport = async (values, id) => {
  const url = `${apiUrl}/sales-region/senior-executive-dropdown-by-area-sales-manager/${id}?search=${values}`;
  const data = await http.get(url);
  return data;
};

const getSalesExecutiveAutoCompleteForReport = async (values, id) => {
  const url = `${apiUrl}/sales-region/sales-executive-dropdown-by-area-senior-executive/${id}?search=${values}`;
  const data = await http.get(url);
  return data;
};
///sales list
const getRegionalManagersReport = async (query) => {
  const url = `${apiUrl}/sales-region/regional-managers-wise-booking-list${query ? `?${query}` : ""}`;
  const data = await http.get(url);
  return data;
};
const getSalesManagersReport = async (query) => {
  const url = `${apiUrl}/sales-region/sales-managers-wise-booking-list${query ? `?${query}` : ""}`;
  const data = await http.get(url);
  return data;
};
const getAreaSalesManagerReport = async (query) => {
  const url = `${apiUrl}/sales-region/area-sales-executive-wise-booking-list${query ? `?${query}` : ""}`;
  const data = await http.get(url);
  return data;
};
const getSeniorManagerReport = async (query) => {
  const url = `${apiUrl}/sales-region/senior-executive-wise-booking-list${query ? `?${query}` : ""}`;
  const data = await http.get(url);
  return data;
};
const getSalesPersonReport = async (query) => {
  const url = `${apiUrl}/sales-region/sales-executive-wise-booking-list${query ? `?${query}` : ""}`;
  const data = await http.get(url);
  return data;
};
export {
  getSalesPersonReport,
  getAreaSalesManagerReport,
  getSeniorManagerReport,
  getSalesManagersReport,
  getRegionalManagersReport,
  getSalesManagerAutoCompleteForReport,
  getAreaSalesManagerAutoCompleteForReport,
  getSeniorExecutiveAutoCompleteForReport,
  getSalesExecutiveAutoCompleteForReport,
  REPORT_FIELDS,
  exportReportFlight,
  getSalesReport,
  getAirlineDetailsForReport,
  getAirportsDetailsForReport,
  getCountryDetailsForReport,
  getStateDetailsForReport,
  getSupplierForReport,
  getSalesUserForReport,
};
